// eslint-disable-next-line complexity
const TITLES = {
  likes: {
    icon: 'heart',
    name: 'curtidas',
  },
  shares: {
    icon: 'share-variant',
    name: 'compartilhamentos',
  },
  comments: {
    icon: 'message-text',
    name: 'comentários',
  },
  videoplays: {
    icon: 'play',
    name: 'visualizações',
  },
  followers: {
    icon: 'account-group',
    name: 'seguidores',
  },
};

export function iconMap(iconTitle) {
  const icon = 'frequently-asked-Questions';
  const name = 'desconhecido';

  let iconTitleFormatted = iconTitle;
  if (iconTitle) iconTitleFormatted = iconTitle.toLowerCase();

  return TITLES[iconTitleFormatted] || { icon, name };
}
